// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBID-2WQ0mnQuW-sswoAGRfllN7GLE_IQY",
  authDomain: "grouplet-2ff3b.firebaseapp.com",
  projectId: "grouplet-2ff3b",
  storageBucket: "grouplet-2ff3b.firebasestorage.app",
  messagingSenderId: "1012316599529",
  appId: "1:1012316599529:web:292cfb2da2f1d294f6ac78",
  measurementId: "G-TQGTVQRGN4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
